import { FC } from 'react'
import { flushSync } from 'react-dom'
import type { LeadProfileLead } from '../../LeadProfileModal.types'
import { UserAddOutlined, UserDeleteOutlined } from '@ant-design/icons'
import classes from './index.module.css'
import { handlerDeleteStudAccount } from './deleteStudAccountModalFn'
import { useAddAlert } from '@/hooks/useAddAlert'
import { useFullLeadModalAccess } from '../../hooks/useFullLeadModalAccess'
import { useLeadRefetch } from '../../LeadRefetchContext'
import Button from '@UI/New/Button'

interface TabBindingStudAccountProps {
  lead: LeadProfileLead
  onOpenStudentAccount: () => void
  onOpenAddStudAccount: () => void
  onRefetchLead: () => void
}

const TabBindingStudAccount: FC<TabBindingStudAccountProps> = ({
  lead,
  onOpenStudentAccount,
  onOpenAddStudAccount,
  onRefetchLead,
}) => {
  const addAlert = useAddAlert()
  const access = useFullLeadModalAccess()
  const { patchLead } = useLeadRefetch()

  if (lead?.user_id) {
    return (
      <div className={classes.studAccountTabWrapper}>
        <div className={classes.boundActions}>
          <Button
            type="button"
            color="primary"
            className={classes.goToLkButton}
            onClick={() => onOpenStudentAccount()}
          >
            Перейти в ЛК
          </Button>
          {access.canBindUnbindStudent && (
            <Button
              type="button"
              color="danger"
              className={classes.unbindIconButton}
              classNames={{ button: classes.unbindIconButtonInner }}
              aria-label="Отвязать личный кабинет студента"
              leftContent={
                <UserDeleteOutlined
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              }
              onClick={() =>
                handlerDeleteStudAccount({
                  lead,
                  addAlert,
                  onSuccess: () => {
                    flushSync(() => {
                      patchLead({ user_id: null, user: null })
                    })
                    onRefetchLead()
                  },
                })
              }
            />
          )}
        </div>
      </div>
    )
  }

  if (!access.canBindUnbindStudent) {
    return null
  }

  return (
    <div className={classes.studAccountTabWrapper}>
      <Button
        type="button"
        color="primary"
        leftContent={
          <UserAddOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        }
        className={classes.bindLkButton}
        onClick={() => onOpenAddStudAccount()}
      >
        Привязать ЛК студента
      </Button>
    </div>
  )
}

export default TabBindingStudAccount
